import React from "react";
import {
  Block,
} from "../../../components/Component";

import moment from "moment";
import { NumericFormat } from "react-number-format";
import Table from "../../../components/react-table/Table";

const BillApprovedComponent = ({
  loading,
  data = {
    ins: [],
    outs: [],
  },
  summary = {
    ins: {},
    outs: {},
  },
  startDate,
  endDate,
  needApproveByUser = [],
  listDayNotYetRequestReview = [],
  reviewerNotConfirms = []
}) => {

  const colTable = [
    {
      Header: "Mã",
      accessor: "id",
    },
    {
      Header: "Ngày",
      accessor: (item) => item.date
    },
    {
      Header: "Hàng hoá",
      accessor: (item) => item?.ingredient?.name || "",
    },
    {
      Header: "KH/NCC",
      accessor: (item) => item?.customer?.name || "",
    },
    {
      Header: "KL Hàng(kg)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item?.finalMerchandiseWeight}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />,
    },
    {
      Header: "Đơn giá(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.unitPrice}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Tiền hàng(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.finalMerchandiseAmount}
        displayType={'text'}
        decimalScale={2}
        thousandSeparator={','}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Ghi chú",
      accessor: (item) => item.note
    },
  ];

  return (<Block>
    <div className="card card-bordered card-preview">
      <div className="card-inner">
        <div
          id="DataTables_Table_1_wrapper"
          className="dataTables_wrapper dt-bootstrap4 no-footer"
        >
          <div>
            <h6>Ngày chưa gửi báo cáo trong tháng: <span className="font-weight-normal">{listDayNotYetRequestReview?.join(', ')}</span></h6>
            <h6>Ngày tôi chưa duyệt: <span className="font-weight-normal">{needApproveByUser?.join(', ')}</span></h6>
            <h6>DS người chưa duyệt: <span className="font-weight-normal" style={{
              whiteSpace: 'pre-line',
            }}>{`\n`}{reviewerNotConfirms.map(e => `${e.name}: ${e.dates.map(d => moment(d, 'YYYY-MM-DD').format('DD-MM-YYYY')).join(', ')}`).join('\n')}</span></h6>
          </div>
          <div className="my-3">
            <h4>Báo cáo chi tiết nhập từ ngày {moment(startDate).format('DD-MM-YYYY')} đến ngày {moment(endDate).format('DD-MM-YYYY')}</h4>
            <Table
              notShowPagi
              loading={loading}
              columns={colTable}
              data={data.ins}
              headerRow={(
                <tr className="nk-tb-item odd font-weight-bold">
                  <td colSpan={4} className="nk-tb-col">
                    <span> Tổng kết ({data.ins?.length || 0} đơn) </span>
                  </td>
                  <td className="nk-tb-col text-right">
                    <NumericFormat
                      value={summary.ins?.finalMerchandiseWeight || 0}
                      displayType={'text'}
                      decimalScale={2}
                      thousandSeparator={','}
                      thousandsGroupStyle="thousand"
                    />

                  </td>
                  <td></td>
                  <td>
                    <NumericFormat
                      value={summary.ins?.finalMerchandiseAmount || 0}
                      displayType={'text'}
                      decimalScale={2}
                      thousandSeparator={','}
                      thousandsGroupStyle="thousand"
                    />
                  </td>
                  <td></td>
                </tr>
              )}
            ></Table>
          </div>
          <div className="my-3">
            <h4>Báo cáo chi tiết xuất từ ngày {moment(startDate).format('DD-MM-YYYY')} đến ngày {moment(endDate).format('DD-MM-YYYY')}</h4>
            <Table
              notShowPagi
              loading={loading}
              columns={colTable}
              data={data.outs}
              headerRow={(
                <tr className="nk-tb-item odd font-weight-bold">
                  <td colSpan={4} className="nk-tb-col">
                    <span> Tổng kết ({data.outs?.length || 0} đơn) </span>
                  </td>
                  <td className="nk-tb-col text-right">
                    <NumericFormat
                      value={summary.outs?.finalMerchandiseWeight || 0}
                      displayType={'text'}
                      decimalScale={2}
                      thousandSeparator={','}
                      thousandsGroupStyle="thousand"
                    />

                  </td>
                  <td></td>
                  <td>
                    <NumericFormat
                      value={summary.outs?.finalMerchandiseAmount || 0}
                      displayType={'text'}
                      decimalScale={2}
                      thousandSeparator={','}
                      thousandsGroupStyle="thousand"
                    />
                  </td>
                  <td></td>
                </tr>
              )}
            ></Table>
          </div>
        </div>
      </div>
    </div>
  </Block>);
};

export default BillApprovedComponent;
